import FormikHomeAssumptionsAvivaOwnLivePage from './FormikHomeAssumptionsAvivaOwnLivePage';

export default FormikHomeAssumptionsAvivaOwnLivePage;
